import { ICONS } from './UiIcon.constants';
import type { UiIconProps } from './UiIcon.types';
import { cn } from '@/lib/tailwind';
import { ICON_COLOR_MAP } from '@/lib/ui/tailwind-mapping.constants';

export function UiIcon({ name, ...props }: UiIconProps) {
    const Icon = ICONS[name];
    const className = props.className || ICON_COLOR_MAP[name] || 'text-primary';

    return <Icon {...props} className={cn('size-full', className)} />;
}
